const constant = {
    FOOD_ICONS: [
        "avocado",
        "bread",
        "cheesecake",
        "cherry",
        "dumplings",
        "egg-2",
        "egg",
        "fries",
        "hamburguer",
        "ice-cream",
        "lamb",
        "nigiri",
        "pizza",
        "soda",
        "steak",
        "sushi",
        "taco",
        "watermelon",
    ],
    DARK_MODE_COLOR: "#18191a",
    LIGHT_MODE_COLOR: "#f6f6f6",
    PRODUCT_TYPES: {
        MENU: "MENU",
        CATALOGUE: "CATALOGUE"
    }
};

export default constant;
